module.exports = __webpack_public_path__ + "assets/img/Nexon-1-Landing-Page-w540.7e42a60e.jpg";